var _excluded = ["height", "width"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

var IconIllustrativeMessage = function IconIllustrativeMessage(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.264 8.114C49.541 2.279 40.618.06 31.692 0 22.77.06 13.845 2.279 8.121 8.114 2.28 13.833.06 22.748 0 31.666.062 40.584 2.28 49.5 8.12 55.22c5.724 5.835 14.65 8.053 23.573 8.114 8.925-.063 17.848-2.28 23.571-8.114 5.84-5.72 8.06-14.637 8.121-23.553-.06-8.918-2.28-17.833-8.12-23.552",
    fill: "#007FF1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.31 27.626h9.117v-1.765H27.31v1.765zm0 4.412h9.117v-1.765H27.31v1.765zm4.558-14.118c-9.27 0-14.588 4.1-14.588 11.25 0 7.096 5.239 11.188 14.385 11.247l-1.222 5.16 9.464-6.537c4.286-1.781 6.55-5.193 6.55-9.87 0-7.15-5.318-11.25-14.589-11.25z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "iconIllustrativeMessage_svg__a",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 30,
    height: 29
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.31 27.626h9.117v-1.765H27.31v1.765zm0 4.412h9.117v-1.765H27.31v1.765zm4.558-14.118c-9.27 0-14.588 4.1-14.588 11.25 0 7.096 5.239 11.188 14.385 11.247l-1.222 5.16 9.464-6.537c4.286-1.781 6.55-5.193 6.55-9.87 0-7.15-5.318-11.25-14.589-11.25z",
    fill: "#fff"
  })));
};

IconIllustrativeMessage.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
export default IconIllustrativeMessage;
//# sourceMappingURL=IconIllustrativeMessage.js.map